var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.bentblocks_een {\r\n\t\tfill: rgba(0, 0, 0, 0.4);\r\n\t}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bentblocks_een",
    d: "M16,4c-2.45,0-3.78,2.086-4.967,3.478C10.319,8.315,8.835,9,7.735,9H6c-1.1,0-2,0.9-2,2v10 c0,1.1,0.9,2,2,2h1.735c1.1,0,2.584,0.685,3.298,1.522C12.226,25.92,13.546,28,16,28c1.1,0,2-0.9,2-2V6C18,4.9,17.1,4,16,4z  M8,21.017C7.912,21.013,6,21,6,21V11c0,0,1.912,0.005,2,0V21.017z M16,26c-1.389,0-2.25-1.375-3.445-2.776 c-0.627-0.735-1.558-1.347-2.555-1.744V10.52c0.997-0.397,1.928-1.009,2.555-1.744C13.742,7.384,14.605,6,16,6V26z M24.456,24.555 l-1.418-1.418c3.95-3.95,3.947-10.327,0-14.274l1.418-1.418C29.185,12.174,29.177,19.833,24.456,24.555z M20.874,10.867 c2.837,2.837,2.833,7.433,0,10.266l-1.416-1.416c2.057-2.057,2.055-5.378,0-7.434L20.874,10.867z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.954225f7ec2f85768298644f0ab94393.svg";
export { ForwardRef as ReactComponent };